// <copyright file="main.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 10/09/2025 by Naziya Firdos
// </copyright>

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { App } from "./app/app";

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
